import { Box, HStack, Text } from '@rbilabs/universal-components';

import { theme } from 'styles/configure-theme';

export const ItemContainer = HStack.withConfig({
  backgroundColor: theme.token('background-pattern'),
  paddingY: '$3',
  paddingX: '$4',
  width: 'full',
  alignItems: 'center',
  borderTopWidth: 1,
  borderTopColor: theme.token('border-default'),
});

export const ItemName = Text.withConfig(({ isAvailable }: { isAvailable: boolean }) => ({
  color: isAvailable ? theme.token('text-default') : theme.token('text-disabled'),
  fontFamily: 'heading',
  marginTop: '$2',
}));

export const PictureContainer = Box.withConfig({
  height: '$17',
  width: '$19',
  alignItems: 'center',
});

export const DetailsContainer = Box.withConfig({
  flex: 1,
  marginLeft: '$4',
});

export const ItemInfoContainer = HStack.withConfig({
  backgroundColor: 'blackOpacity.5',
  paddingX: '$4',
  paddingY: '$2',
  marginTop: '$1',
});

export const InfoText = Text.withConfig({
  marginLeft: '$2',
});
